import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../../services/error-message.service';
import { useSnackbars } from '../../../../hooks/snackbar.hook';
import MeterReadingForm from '../../../../components/forms/meter-reading/meter-reading.form';
import moment from 'moment';
import { createMeterReadingLoggedOff } from '../../../../services/requests.service';
import { MeterReadingLoggedOffDto } from '../../../../services/dtos/meter-reading-logged-off.dto';

/**
 * Page relevé de compteur
 * @constructor
 */
export default function MeterReadingLoggedOffPage() {
    //Navigate pour aller sur une nouvelle page
    const navigate = useNavigate();
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    //Ajout des useState
    const [validForm, setValidForm] = useState(true);
    //Récupération objet en session
    const values = localStorage.getItem('meterReadingInfos');

    // Récupère les données du back permettant de construire la page
    useEffect(() => {
        if (!values) {
            navigate('/releve-mon-compteur');
        }
        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Handler utilisé lors du submit du formulaire
    const handleSumbitForm = (form: any) => {
        //Concaténation des champs en une seul valeur
        const index =
            form.numberOne?.toString() +
            form.numberTwo?.toString() +
            form.numberThree?.toString() +
            form.numberFour?.toString() +
            form.numberFive?.toString();
        //Action que si il y a un objet en session
        if (values) {
            setValidForm(false);
            let infosPayment: MeterReadingLoggedOffDto = JSON.parse(values);
            infosPayment = {
                ...infosPayment,
                date: moment(form.date, true).format('yyyy-MM-DD'),
                index: parseInt(index),
            };
            //On met à jour le recaptcha
            createMeterReadingLoggedOff(infosPayment)
                .then(() => {
                    //Redirection sur l'url si fournit
                    showMessage.successAlert('Votre relevé de compteur est enregistré.');
                    localStorage.removeItem('meterReadingInfos');
                    navigate('/');
                })
                .catch((error: Error | AxiosError) => {
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    setValidForm(false);
                });
        }
    };

    //Appel de la vue qui est retournée
    return (
        <MeterReadingForm
            lastAsk={undefined}
            address={undefined}
            handleSumbitForm={handleSumbitForm}
            validForm={validForm}
            id={undefined}
        ></MeterReadingForm>
    );
}
